import {Parameter, ToolboxWatermarkWatermark} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export enum WatermarkMode {
	TEXT = "text",
	IMAGE = "image"
}

export class PortalToolboxWatermarkWatermark extends ToolboxWatermarkWatermark implements Parameter {
	public mode?: WatermarkMode;

	constructor(data: any) {
		super(data);

		this.mode = FunctionHelper.exists(data?.mode) ? data.mode : WatermarkMode.TEXT;
	}

	public static getModeDefault(): WatermarkMode {
		return WatermarkMode.TEXT;
	}

	public static fromJson(data: any): PortalToolboxWatermarkWatermark {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalToolboxWatermarkWatermark(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'mode': this.mode
		};
	}

	public clone(): PortalToolboxWatermarkWatermark {
		return PortalToolboxWatermarkWatermark.fromJson(this.toJson());
	}
}